/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Box, CircularProgress } from '@mui/material';

interface ILoader {
  showLoader: boolean;
  isCenter?: boolean;
  customClasses?: string;
};

const Loader = ({ showLoader, isCenter, customClasses }: ILoader) => {
  if (!showLoader) return null;
  const boxProps = isCenter ? { sx: { textAlign: 'center', alignItems: 'center' } } : {};
  return (
    <Box id="circular-progress-container" {...boxProps} className={customClasses}>
      <CircularProgress id="circular-progress" variant="indeterminate" />
    </Box>
  );
};

export default Loader;
